<template>
  <div class="content">
    <a-modal
      width="90%"
      v-model="visible"
      title=""
      centered
      @ok="handleOk"
      :footer="null"
      :maskClosable="false"
      :closable="false"
    >
      <div class="resCantainer">
        <div v-if="status == 0" class="resultContent"><div class="icon"><a-icon type="check-circle" /></div><div class="text">{{ statusArray[status] }}</div></div>
        <div v-else class="resultContent"><div class="err-icon"><a-icon type="exclamation-circle" /></div><div class="text">{{ statusArray[status] }}</div></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: 0,
      visible: false,
      statusArray: ["登录成功", "二维码超时", "未关注公众号", "未绑定学籍信息"],
    };
  },
  methods: {
    async getDetailInfo() {
      this.status = this.$route.query.status || 0;
      console.log("获取登录结果信息", this.status);
      this.showModal();
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.visible = false;
    },
  },
  mounted() {
    this.getDetailInfo();
  },
};
</script>

<style lang="scss" scoped>
.resCantainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  padding-top: 160px;
  padding-bottom: 160px;
}
.resultContent {
  display: flex;
  align-items: center;
  font-size: 94px;
  font-weight: bold;
  text-align: center;
  color: #333;
  .icon {
    font-size: 120px;
    color: #52c41a;
    margin-right: 20px;
    display: flex;
    align-items: center; // 让icon自身内容也居中
    line-height: 1; // 避免字体撑高
  }
  .err-icon {
    font-size: 120px;
    color: #f5222d;
    margin-right: 20px;
    display: flex;
    align-items: center; // 让icon自身内容也居中
    line-height: 1; // 避免字体撑高
  }
  .text {
    display: flex;
    align-items: center; // 让文字内容也居中
    height: 120px; // 与icon高度一致
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/QRCodeLoginResult/index.vue